/**
 * Shared Emotion cache key for all islands. The client uses one shared cache object (Emotion's
 * intended pattern), and each SSR render uses a per-render cache under this same key so server styles
 * hydrate against the client cache. Emotion only permits [a-z-], so keep this a plain hyphenated string.
 */
export const EMOTION_CACHE_KEY = 'rp-island';
